import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/fyai-home/page";
import FyaiDownload from "../pages/fyai-download/page";
import FyaiReport from "../pages/fyai-report/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/download",
    element: <FyaiDownload />,
  },
  {
    path: "/report",
    element: <FyaiReport />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;